var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"tag":"li","to":_vm.path},nativeOn:{"click":function($event){_vm.toggleMobileMenu ? _vm.toggleMobileMenu : ''}}},[_c('a',[_vm._v(_vm._s(_vm.$t(`menus.${_vm.data.path}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }